import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {ProductOptionsModel} from "../models/view/productOptionsModel";
import {useAppContext} from "./useAppContext";

export const useProductOptionsQuery = () => {
    const {productId} = useAppContext();
    const {model: {options}} = useProductDetailsQuery();
    return {model: new ProductOptionsModel(productId, options)};
}